
import BaseModel from './BaseModel';
export default class HomestayRateTranslate extends BaseModel {
    constructor(data = {}) {
        super(data)
        this.setData(data);
    }

    setData(data = this.__data__) {
        this.homestayRatePlanId = data.id
        this.name = data.name
        this.description = data?.description
        this.order = data.order
        this.shortDescription = data?.shortDescription || []
        this.cancelPolicy = data?.cancelPolicy || []
        this.isActive = data.isActive
        this.languageCode = data.languageCode
        this.usageStatus = data.usageStatus
        this.targetLanguage = data?.targetLanguage || []
        this.isIndependent = data?.isIndependent || undefined
    }

    export() {
        const result = {
            homestayRatePlanId: this.homestayRatePlanId,
            name: this.name,
            description: this.description,
            order: this.order,
            shortDescription: this.shortDescription,
            cancelPolicy: this.cancelPolicy,
            isActive: this.isActive,
            languageCode: this.languageCode,
            usageStatus: this.usageStatus,
            targetLanguage: this.targetLanguage,
            isIndependent: this.isIndependent
        };
        return result;
    }
}